export default class Config {
    idCard?: boolean;
    maxTopUp?: number;
}